import React from 'react';
import styled from 'styled-components';
import { GridFooterContainer } from '@mui/x-data-grid';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from 'shared/utils/translation';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import TablePaginationControls from 'talent_matching/components/table/table_pagination_controls';

const t = withLocalePrefix('talent_matching');

const TableFooterContainer = styled(GridFooterContainer)`
  min-height: 56px;
  height: auto;
  padding: ${Tokens.spacing['1']} ${Tokens.spacing['2']};
  box-sizing: border-box;

  &.MuiDataGrid-withBorderColor {
    border-top: none;
  }
`;

type Props = {
  currentPage: number;
  totalRows: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

const AppReviewTableFooter = ({
  currentPage,
  totalRows,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: Props) => {
  const { canViewTalentMatchingAiMatchScore } = useTalentMatchingTabContext();

  return (
    <TableFooterContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        flexWrap="wrap"
        sx={{ width: '100%' }}
      >
        <div>
          {canViewTalentMatchingAiMatchScore && (
            <SecondaryBody metadata>
              {t('table.footer.ai_disclaimer')}
            </SecondaryBody>
          )}
        </div>
        <TablePaginationControls
          currentPage={currentPage}
          totalRows={totalRows}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Stack>
    </TableFooterContainer>
  );
};

export default AppReviewTableFooter;
